import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";

export const CookieBanner = () => {
  const { t } = useLang();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("cookie_consent")) setVisible(true);
  }, []);

  const decide = (value) => {
    localStorage.setItem("cookie_consent", value);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-0 left-0 right-0 z-[60] bg-[#0A0A0C]/95 backdrop-blur-md border-t border-white/10 px-6 md:px-16 py-5"
    >
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row md:items-center gap-4">
        <p className="text-sm text-zinc-300 flex-1 leading-relaxed">
          {t("cookieMsg")}{" "}
          <Link to="/legal/cookies" className="text-[#E11D48] hover:underline font-medium" data-testid="cookie-learn-more">
            {t("cookiesPolicy")}
          </Link>
          <span className="text-zinc-500 mx-1.5">·</span>
          <Link to="/legal/privacidad" className="text-zinc-400 hover:text-white underline text-xs" data-testid="cookie-privacy-link">
            {t("privacy")}
          </Link>
        </p>
        <div className="flex items-center gap-3 shrink-0">
          <button
            data-testid="cookie-reject"
            onClick={() => decide("rejected")}
            className="px-5 py-2.5 text-sm border border-white/20 text-zinc-300 hover:bg-white/5 transition-colors"
          >
            {t("reject")}
          </button>
          <button
            data-testid="cookie-accept"
            onClick={() => decide("accepted")}
            className="px-6 py-2.5 text-sm bg-[#E11D48] text-white font-medium hover:bg-[#BE123C] transition-colors"
          >
            {t("accept")}
          </button>
        </div>
      </div>
    </div>
  );
};
